import { UAParser } from 'ua-parser-js';
import { DevicesCategory } from '@app/api';

export const useBrowserDeviceCategory = () => {
  const parser = new UAParser();
  const device = parser.getResult().device;
  if (device.type === 'tablet') {
    return DevicesCategory.TABLET;
  }
  if (device.type === 'mobile') {
    return DevicesCategory.SMARTPHONE;
  }
  return DevicesCategory.COMPUTER;
};
